import axios from 'axios';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import toast from 'react-hot-toast';
import useToggle from '../../Hooks/useToggle';
import { ExportExcel } from '../../utils/Excel/exportExcel';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { useHistory } from 'react-router-dom';

ChartJS.register(ArcElement, Tooltip, Legend);


const AdminReports = () => {

    const [modal, toggleModal] = useToggle(false);

    const toastConfig = {
        loading: 'Obteniendo Datos...',
        success: <b>Hecho</b>,
        error: <b>Error.</b>,
    }

    function company(query = {}) {
        toast.promise(
            axios.get("report/company-audience", { params: query })
                .then(res => ExportExcel(res.data, "company_audience")),
            toastConfig
        )
    }

    function students(query = {}) {
        toast.promise(new Promise(async (resolve, reject) => {
            try {
                const res = await axios.get("report/company-audience", { params: query })
                resolve(ExportExcel(res.data, "student_audience"))
            } catch (e) {
                reject(e)
            }
        }), toastConfig)
    }

    return (
        <>
            <main className='container' id="admin">
                <br /><br />

                <div className='row'>

                    <div className='col-12 col-lg-6'>
                        <div className='card border-radius mt-5'>
                            <div className='card-body'>
                                <h5>Reporte de Audiencia Compañia y Aplicante</h5>
                                <div className="row">
                                    <div className="col-12  col-lg-12 d-flex align-items-center flex-column py-1">
                                        <button className='btn btn--gradient mb-3 mt-3' style={{ width: "fit-content", padding: "5px 10px" }} onClick={toggleModal}>Descargar Reporte</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-12  col-lg-6 '>
                        <VacantReport1 />
                    </div>
                    <div className='col-12  col-lg-6 '>
                        <AplicantsReport />
                    </div>
                    <div className='col-12  col-lg-6'>
                        <UsersReports />
                    </div>
                    <div className='col-12  col-lg-6'>
                    <VacanteArea />
                    </div>
                    <div className='col-12  col-lg-6'>
                    <GroupsReport />
                    </div>
                </div>
            </main>

            <ModalReport show={modal} onHide={toggleModal} reportApplicant={students} reportCompany={company} />
        </>
    );
};

function GroupsReport() {

    const history = useHistory();

    return (
        <>
            <div className='col-12 col-lg-12 '>

                <div className='card border-radius mt-5'>
                    <div className='card-body'>
                        <h5>Reporte de Grupos</h5>
                        <div className="row">
                            <div className="col-12 col-lg-12 d-flex align-items-center flex-column p-3">
                                <button className="btn btn--gradient mb-3 mt-3" onClick={() => history.push("/admin/groupsreport")} style={{ width: "fit-content", padding: "5px 10px" }}>
                                    Ver Reporte 
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

function VacantReport1() {
    const history = useHistory();


    return (
        <>
            <div className='col-12 col-md-12 col-lg-12 '>
                <div className='card border-radius mt-5'>
                    <div className='card-body'>
                        <h5>Reporte General Vacante y Aplicante</h5>
                        <div className="row">
                            <div className="col-12  col-lg-12 d-flex align-items-center flex-column p-3">
                                <button className="btn btn--gradient mb-3 mt-3" onClick={() => history.push("/admin/vacantreport")} style={{ width: "fit-content", padding: "5px 10px" }}>
                                    Ver Reporte
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

function UsersReports() {

    const history = useHistory();

    return (
        <>
            <div className='col-12 col-md-12 col-lg-12 '>
                <div className='card border-radius mt-5'>
                    <div className='card-body'>
                        <h5>Reporte de Usuario</h5>

                        <div className="row">
                            <div className="col-12  col-lg-12 d-flex align-items-center flex-column p-3">
                                <button className="btn btn--gradient mb-3 mt-3" onClick={() => history.push("/admin/usersreports")} style={{ width: "fit-content", padding: "5px 10px" }}>
                                    Ver Reporte
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

function AplicantsReport() {

    const history = useHistory()

    return (
        <>
            <div className='col-12 col-md-12 col-lg-12'>
                <div className='card border-radius mt-5'>
                    <div className='card-body'>
                        <h5>Reporte Aplicante</h5>
                        <div className="row">
                            <div className="col-12 col-md-12 col-lg-12 d-flex align-items-center flex-column p-3">
                                <button className="btn btn--gradient mb-3 mt-3" onClick={() => history.push("/admin/aplicantsreport")} style={{ width: "fit-content", padding: "5px 10px" }}>
                                    Ver Reporte
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

function getMonth(month) {

    if (month >= 9) {
        return month + 1
    }

    return "0" + (month + 1)
}

function getDay(day) {
    if (day >= 10) {
        return day
    }

    return "0" + day
}

const ModalReport = ({ show, onHide, reportCompany, reportApplicant }) => {

    const [reportType, setReportType] = useState(1)
    const [range, setRange] = useState([null, null])

    function onReportTypeChange(e) {
        let { target: { value } } = e;
        setReportType(parseInt(value))
    }

    function onStartChange(e) {
        let { target: { value } } = e

        if (value === "") {
            onClean()
            return
        }

        const end = range[1];

        setRange([
            new Date(value),
            end
        ])
    }

    function onEndChange(e) {
        let { target: { value } } = e

        if (value === "") {
            onClean()
            return
        }

        const start = range[0];

        setRange([
            start,
            new Date(value)
        ])
    }

    function onClean() {
        setRange([null, null])
        document
            .querySelectorAll(".report_date")
            .forEach(elm => {
                elm.value = ""
            })
    }

    function onSubmit() {

        let query = {}
        const [startDate, endDate] = range;

        if (startDate !== null && endDate !== null) {

            query = {
                startDate: `${startDate.getFullYear()}-${getMonth(startDate.getMonth())}-${getDay(startDate.getDate())}`,
                endDate: `${endDate.getFullYear()}-${getMonth(endDate.getMonth())}-${getDay(endDate.getDate())}`
            }
        }

        if (reportType === 1) {
            reportCompany(query)
        } else {
            reportApplicant(query)
        }

        onClean()
        onHide()
    }

    return (
        <Modal className='border-radius' size='lg' show={show} onHide={onHide}>

            <Modal.Header>
                <Modal.Title>Reporte general de audiencia</Modal.Title>
            </Modal.Header>

            <Modal.Body>

                <section className='card'>
                    <div className='card-body my-3'>
                        <div className='form-group'>
                            <label>Seleccione el tipo de reporte</label>
                            <select className='form-control' onChange={onReportTypeChange} defaultValue={reportType}>
                                <option value={1}>Reportes de compañias</option>
                                <option value={2}>Reportes de Aplicantes</option>
                            </select>
                        </div>
                    </div>
                </section>


                <div className='card my-3'>
                    <div className='card-body'>
                        <label>
                            Seleccione el rango de fecha de usuarios creados &nbsp;
                            <small>deje en blanco para ver todos</small>
                        </label>
                        <br />
                        <section className="row mt-3">


                            <div className='col-6'>
                                <label>Inicio</label>
                                <input type='date' onChange={onStartChange} className='form-control report_date' />
                            </div>

                            <div className='col-6'>
                                <label>Fin</label>
                                <input type='date' onChange={onEndChange} className='form-control report_date' />
                            </div>
                        </section>
                    </div>
                </div>



                <button className='btn-deg' onClick={onSubmit}>Descargar reporte</button>

            </Modal.Body>
        </Modal>
    );
}

function VacanteArea() {

    const history = useHistory();
    return (
        <>
            <div className='col-12 col-lg-12 '>
                <div className='card border-radius mt-5'>
                    <div className='card-body'>
                        <h5>Reporte Vacante Area</h5>
                        <div className="row">
                            <div className="col-12 col-lg-12 d-flex align-items-center flex-column p-3">
                                <button className="btn btn--gradient mb-3 mt-3" onClick={() => history.push("/admin/vacantearea")} style={{ width: "fit-content", padding: "5px 10px" }}>
                                    Ver Reporte
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


export default AdminReports;